export default "__VITE_ASSET__viD9eCFD__"